import request from '@/request'

/**
 * 自定义小程序 数据列表
 * @param data
 * @returns {AxiosPromise}
 */
export function program_list(data) {
  return request({
    url: '/api/v1/auto/data_list',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 上传查询数据
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_modify_data(data) {
  return request({
    url: '/api/v1/auto/modify_data',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 清除查询数据
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_clean_data(data) {
  return request({
    url: '/api/v1/auto/clean_data',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取岗位查询表数据
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_data(data) {
  return request({
    url: '/api/v1/auto/get_data',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获得所有的表格
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_table(data) {
  return request({
    url: '/api/v1/auto/get_table',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 新增数据表格
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_modify_table(data) {
  return request({
    url: '/api/v1/auto/modify_table',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 新增数据表格字段
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_modify_table_field(data) {
  return request({
    url: '/api/v1/auto/modify_table_field',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取数据表格字段( 设置界面 )
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_table_field(data) {
  return request({
    url: '/api/v1/auto/get_table_field',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取指定数据表格表头( table 表格展示作用 )
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_table_col(data) {
  return request({
    url: '/api/v1/auto/get_table_col',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取指定数据表格表头( table 表格展示作用 )
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_table_source(data) {
  return request({
    url: '/api/v1/auto/get_table_source',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 生成指定数据表格表头( 用作数据检索 )
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_modify_table_source(data) {
  return request({
    url: '/api/v1/auto/modify_table_source',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 生成自定义小程序
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_program(data) {
  return request({
    url: '/api/v1/auto/modify_program',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取数据表格
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_program(data) {
  return request({
    url: '/api/v1/auto/auto_get_program',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 生成小程序推广员
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_add_member(data) {
  return request({
    url: '/api/v1/auto/add_member',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 获取小程序推广员列表
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_get_member(data) {
  return request({
    url: '/api/v1/auto/get_member_list',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 小程序推广员 生成二维码
 * @param data
 * @returns {AxiosPromise}
 */
export function create_qr(data) {
  return request({
    url: '/api/v1/auto/create_qr',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 小程序推广员 生成二维码
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_collect_list(data) {
  return request({
    url: '/api/v1/auto/collect_list',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 导出收集数据
 * @param data
 * @returns {AxiosPromise}
 */
export function auto_export_data(data) {
  return request({
    url: '/api/v1/auto/export_data',
    responseType: 'blob',
    method: 'POST',
    data: data,
  })
}

/**
 * 自定义小程序 移除字段
 * @param data
 * @returns {AxiosPromise}
 */
export function remove_item(data) {
  const url = '/api/v1/auto/remove_item'
  return request({ url, method: 'POST', data })
}

/**
 * 自定义小程序 获取自定义规则
 * @param data
 * @returns {AxiosPromise}
 */
export function get_auto_rule(data) {
  const url = '/api/v1/auto/get_auto_rule'
  return request({ url, method: 'POST', data })
}
